/**
 * Cookie consent state: shared between the React tree (CookieConsentContext)
 * and plain JS modules (fbPixel.js) via localStorage + a CustomEvent.
 */

export const COOKIE_CONSENT_STORAGE_KEY = 'COOKIE_CONSENT';
export const COOKIE_CONSENT_EVENT = 'cookieConsentChange';

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_REJECTED = 'rejected';

export const getStoredConsent = () => {
    try {
        const value = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
        return value === CONSENT_ACCEPTED || value === CONSENT_REJECTED ? value : null;
    } catch (error) {
        return null;
    }
};

export const setStoredConsent = (value) => {
    try {
        if (value === CONSENT_ACCEPTED || value === CONSENT_REJECTED) {
            localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, value);
        } else {
            localStorage.removeItem(COOKIE_CONSENT_STORAGE_KEY);
        }
    } catch (error) {
        // localStorage unavailable (e.g. private mode) - consent simply won't persist
    }

    window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, {detail : value}));
};

export const hasAcceptedConsent = () => getStoredConsent() === CONSENT_ACCEPTED;
